/**
 * Ритуал: мирный захват пустой соты (docs/06-territory.md §11.1, Э4.2).
 *
 * Назначение файла: ставка и порог Следа без дублирования чисел в сервере.
 */

import { RITUAL, SIEGE_STAKE } from "./constants.js";
import { traceQualityRank } from "./traces.js";
import { type Crystals, type TraceQuality } from "./types.js";

/** Ставка ритуала в ☾: кольцо 1 от Очага бесплатно. */
export function ritualStakeCrystals(nearOwnHearth: boolean): Crystals {
  return nearOwnHearth ? 0 : SIEGE_STAKE.empty;
}

/** Мана за ритуал (Э4.2). */
export function ritualManaCost(): number {
  return RITUAL.manaCost;
}

/** След годится для ритуала, если не слабее Верного. */
export function isRitualTraceQuality(quality: TraceQuality): boolean {
  return traceQualityRank(quality) >= traceQualityRank("true");
}
